export default "__VITE_ASSET__5x4dgAMs__"